import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { updateUserProfile } from '../services/userService';
import { auth } from '../firebase/config';
import { checkUrlExists } from '../services/listingService';

const ProfileCompletion = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [websiteUrl, setWebsiteUrl] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const validateUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!firstName.trim()) {
      setError('First name is required');
      return;
    }

    let formattedWebsiteUrl = websiteUrl;
    if (!formattedWebsiteUrl.startsWith('http://') && !formattedWebsiteUrl.startsWith('https://')) {
      formattedWebsiteUrl = 'https://' + formattedWebsiteUrl;
    }

    if (!validateUrl(formattedWebsiteUrl)) {
      setError('Please enter a valid URL');
      return;
    }

    setIsSubmitting(true);

    try {
      // Check if URL already exists
      console.log('Checking if URL exists:', formattedWebsiteUrl);
      const urlExists = await checkUrlExists(formattedWebsiteUrl);
      if (urlExists) {
        setError('This website URL is already listed.');
        return;
      }

      await updateUserProfile(auth.currentUser.uid, {
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        websiteUrl: formattedWebsiteUrl.trim(),
      });

      navigate('/edit-listing', { 
        state: { 
          url: formattedWebsiteUrl.trim(),
          email: auth.currentUser.email 
        }
      });
    } catch (error) {
      setError(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold text-center mb-6">Submit your first listing</h2>
      
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      )}

      <div className="mb-4">
        <p className="text-green-600 text-center">
          Verification email has been sent to your email address.
          You can complete your profile while waiting for verification.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 mb-2">
            First Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            className="w-full px-3 py-2 border rounded-lg"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
        </div>

        <div className="text-sm text-gray-500 italic mb-4">
          Your first and last name are for profile information only and will not be displayed in the listing.
        </div>

        <div>
          <label className="block text-gray-700 mb-2">
            Last Name
          </label>
          <input
            type="text"
            className="w-full px-3 py-2 border rounded-lg"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">
            Website to List <span className="text-red-500">*</span>
          </label>
          <p className="text-sm text-gray-600 mb-2">
            Enter the URL of the website you want to add to the directory.
            This website will be analyzed and listed in our directory.
          </p>
          <input
            type="text"
            className="w-full px-3 py-2 border rounded-lg"
            value={websiteUrl}
            onChange={(e) => setWebsiteUrl(e.target.value)}
            placeholder="https://example.com"
          />
        </div>

        <button
          type="submit"
          className="w-full bg-red-600 text-white py-2 rounded-lg hover:bg-red-700 disabled:bg-red-300"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Saving...' : 'Submit Listing'}
        </button>
      </form>
    </div>
  );
};

export default ProfileCompletion;
